import { MAKE, TIMELY, ZAPIER } from 'constants/known-apps';
import { appIcons } from 'constants/known-apps.icons';
import type { Integration } from 'factories/apps';

export const timelyApi: Integration = {
  id: TIMELY,
  displayName: 'Timely API',
  description: 'Integrate Timely with your favorite applications.',
  logoUrl: appIcons[TIMELY]!,
  url: 'https://developer.timely.com',
};

export const timelyWebhooks: Integration = {
  id: TIMELY,
  displayName: 'Timely Webhooks',
  description: 'Build your own integrations based on what is happening inside Timely.',
  logoUrl: appIcons[TIMELY]!,
  navLink: '/settings/webhooks',
};

export const zapier: Integration = {
  id: ZAPIER,
  displayName: 'Zapier',
  description:
    'Automate and create your own workflows between Timely and thousands of apps with Zapier.',
  logoUrl: appIcons[ZAPIER]!,
  url: 'https://zapier.com/apps/timely-time-tracking/integrations',
};

export const make: Integration = {
  id: MAKE,
  displayName: 'Make',
  description:
    'Automate and create your own workflows between Timely and thousands of apps with Make.',
  logoUrl: appIcons[MAKE]!,
  url: 'https://www.make.com/en/integrations/timelyapp',
};

const categoryLabels = [
  'Ecosystem',
  'Tracked by Memory',
  'Time tracking integrations',
  'Sync integrations',
  'Reporting',
  'Advanced tools',
] as const;

export const categories = categoryLabels.map(o => ({
  label: o,
  value: o.toLowerCase().split(' ').join('-'),
}));
